/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
import api from "axios";
import { toast } from "sonner";

export default api;

export const coinImages = {
  btc: "https://babebitstore.s3.us-west-2.amazonaws.com/bitcoin-btc-logo.png",
  ltc: "https://babebitstore.s3.us-west-2.amazonaws.com/litecoin-ltc-logo.png",
  dash: "https://babebitstore.s3.us-west-2.amazonaws.com/dash-dash-logo.png",
  eth: "https://babebitstore.s3.us-west-2.amazonaws.com/ethereum-eth-logo.png",
  bch: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png?v=024",
  tusd: "https://babebitstore.s3.us-west-2.amazonaws.com/trueusd-tusd-logo.png",
  usdc: "https://babebitstore.s3.us-west-2.amazonaws.com/usd-coin-usdc-logo.png",
  usdt: "https://babebitstore.s3.us-west-2.amazonaws.com/tether-usdt-logo.png",
};

export const buySellCoins = {
  btc: "https://babebitstore.s3.us-west-2.amazonaws.com/bitcoin-btc-logo.png",
  eth: "https://babebitstore.s3.us-west-2.amazonaws.com/ethereum-eth-logo.png",
  usdt: "https://babebitstore.s3.us-west-2.amazonaws.com/tether-usdt-logo.png",
  bch: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png?v=024",
  tusd: "https://babebitstore.s3.us-west-2.amazonaws.com/trueusd-tusd-logo.png",
  usdc: "https://babebitstore.s3.us-west-2.amazonaws.com/usd-coin-usdc-logo.png",
  ltc: "https://babebitstore.s3.us-west-2.amazonaws.com/litecoin-ltc-logo.png",
  dash: "https://babebitstore.s3.us-west-2.amazonaws.com/dash-dash-logo.png",
};
export const p2pCoins = {
  bitcoin:
    "https://babebitstore.s3.us-west-2.amazonaws.com/bitcoin-btc-logo.png",
  // eth: "https://babebitstore.s3.us-west-2.amazonaws.com/ethereum-eth-logo.png",
  usdt: "https://babebitstore.s3.us-west-2.amazonaws.com/tether-usdt-logo.png",
};

export const Coins = [
  {
    name: "Bitcoin",
    value: "btc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/bitcoin-btc-logo.png",
  },
  {
    name: "USDT",
    value: "usdt",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/tether-usdt-logo.png",
  },
  {
    name: "Litecoin",
    value: "ltc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/litecoin-ltc-logo.png",
  },
  {
    name: "Ethereum",
    value: "eth",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/ethereum-eth-logo.png",
  },
  {
    name: "Bitcoin Cash",
    value: "bch",
    image: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png?v=024",
  },
  {
    name: "Dash",
    value: "dash",
    image: "https://babebitstore.s3.us-west-2.amazonaws.com/dash-dash-logo.png",
  },
  {
    name: "TUSD",
    value: "tusd",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/trueusd-tusd-logo.png",
  },
  {
    name: "USDC",
    value: "usdc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/usd-coin-usdc-logo.png",
  },
];
export const chartCoins = [
  {
    name: "Bitcoin",
    value: "btc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/bitcoin-btc-logo.png",
    color: "yellow",
  },
  {
    name: "USDT",
    value: "usdt",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/tether-usdt-logo.png",
    color: "green",
  },
  {
    name: "Litecoin",
    value: "ltc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/litecoin-ltc-logo.png",
    color: "blue",
  },
  {
    name: "Ethereum",
    value: "eth",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/ethereum-eth-logo.png",
    color: "gray",
  },
  {
    name: "Bitcoin Cash",
    value: "bch",
    image: "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png?v=024",
    color: "green",
  },
  {
    name: "Dash",
    value: "dash",
    image: "https://babebitstore.s3.us-west-2.amazonaws.com/dash-dash-logo.png",
    color: "blue",
  },
  // { name: "TUSD", value: 'tusd', image: "https://babebitstore.s3.us-west-2.amazonaws.com/trueusd-tusd-logo.png", color: 'indigo' },
  {
    name: "USDC",
    value: "usdc",
    image:
      "https://babebitstore.s3.us-west-2.amazonaws.com/usd-coin-usdc-logo.png",
    color: "blue",
  },
];

export function getFlagEmoji(countryCode: string) {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function removeUndefinedAndNull<T>(obj: T | any): T {
  // Use Object.entries to get key-value pairs of the object
  const filteredObject = Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined || value !== null || value !== ""
    )
  );
  return filteredObject as T;
}
export function removeFalse<T>(obj: T | any): T {
  // Use Object.entries to get key-value pairs of the object
  const filteredObject = Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== false)
  );
  return filteredObject as T;
}

export const myPortableTextComponents = {
  // types: {
  //   // eslint-disable-next-line @next/next/no-img-element
  //   image: ({ value }: any) => <img src={urlFor(value).url() ?? ''} alt={value?.alt ?? ""} loading="lazy" />,
  //   callToAction: ({ value, isInline }: any) =>
  //     isInline ? (
  //       <a href={value.url}>{value.text}</a>
  //     ) : (
  //       <div className="callToAction">{value.text}</div>
  //     ),
  // },

  marks: {
    link: ({ children, value }: any) => {
      const rel = !value.href.startsWith("/")
        ? "noreferrer noopener"
        : undefined;
      return (
        <a href={value.href} rel={rel}>
          {children}
        </a>
      );
    },
    em: ({ children }: any) => (
      <em className="text-gray-600 font-semibold dark:text-white">
        {children}
      </em>
    ),
    strong: ({ children }: any) => (
      <strong className=" font-semibold dark:text-white">{children}</strong>
    ),
    underline: ({ children }: any) => (
      <span className="underline dark:text-white">{children}</span>
    ),
  },
  block: {
    // Ex. 1: customizing common block types
    h1: ({ children }: any) => (
      <h1 className="text-6xl font-semibold dark:text-white">{children}</h1>
    ),
    h2: ({ children }: any) => (
      <h2 className="text-5xl font-semibold dark:text-white">{children}</h2>
    ),
    h3: ({ children }: any) => (
      <h3 className="text-4xl font-semibold dark:text-white">{children}</h3>
    ),
    h4: ({ children }: any) => (
      <h4 className="text-3xl font-semibold dark:text-white">{children}</h4>
    ),
    h5: ({ children }: any) => (
      <h5 className="text-2xl font-semibold dark:text-white">{children}</h5>
    ),
    blockquote: ({ children }: any) => (
      <blockquote className="dark:text-white">{children}</blockquote>
    ),
    normal: ({ children }: any) => (
      <div className="dark:text-white">{children}</div>
    ),
  },
  list: {
    // Ex. 1: customizing common list types
    bullet: ({ children }: any) => (
      <ul className="mt-xl list-disc dark:text-white">{children}</ul>
    ),
    number: ({ children }: any) => (
      <ol className="mt-lg dark:text-white">{children}</ol>
    ),
  },
};

export const copy = async (id: string) => {
  await navigator.clipboard.writeText(id);
  toast.success("item copied!");
};

export const formatNumber = (number: any) => {
  const formattedNumber = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
  return formattedNumber;
};

export const doneLanguages = ["en", "fr", "sw", "es", "zh"];

export function getUniqueArrayByKey<T>(array: T[], key: keyof T): T[] {
  const uniqueMap = new Map();
  array.forEach((item) => {
    if (!uniqueMap.has(item[key])) {
      uniqueMap.set(item[key], item);
    }
  });
  return Array.from(uniqueMap.values()) as T[];
}

export const isAddressCaseSensitive = (ticker: string, returnText: any) => {
  const caseSensitiveCoins = ["SOL"];

  const isCaseSensitive = caseSensitiveCoins?.includes(ticker?.toUpperCase());

  return isCaseSensitive ? returnText : null;
};

export const sanitizeKey = (text: string) => text.replace(/[^a-zA-Z0-9]/g, "_");
